<template>
    <div class="recruitment_position">
        <div class="header_box">
            <div class="condition_box">
                <div class="label_box">职位类型：</div>
                <div class="value_box">
                    <div
                        :class="[
                            'job-type-item',
                            {
                                active:
                                    (!!filter.position_type && filter.position_type === item.label) ||
                                    (!filter.position_type && item.label === '全部'),
                            },
                        ]"
                        v-for="item in positionTypeList"
                        :key="item.id"
                        @click="handleChangePositionType(item)"
                    >
                        {{ item.label }}({{ item.num }})
                    </div>
                </div>
            </div>
            <div class="condition_select">
                <FilterConfigs ref="filterConfigsRef" keys="city,experience,degree,salary" @change="handleFilterChange"></FilterConfigs>

                <el-input
                    class="filter-keyword"
                    v-model="filter.keyword"
                    placeholder="查找职位中包含的关键词"
                    suffix-icon="el-icon-search"
                    @change="getJobList"
                    clearable
                ></el-input>
            </div>
        </div>

        <div class="job-box">
            <div class="box-main" v-if="jobList.length > 0">
                <div class="job-list">
                    <RecJobList
                        :list="jobList"
                        :check="currentJob"
                        :isCompany="false"
                        @change="
                            ($event) => {
                                currentJob = $event;
                                getJobDetail(currentJob);
                            }
                        "
                    ></RecJobList>

                    <div class="pagination flex-center">
                        <el-pagination
                            @current-change="handlePageChange"
                            background
                            :page-size="pageParams.page_size"
                            layout="prev, pager, next"
                            :total="pageParams.total"
                        >
                        </el-pagination>
                    </div>
                </div>

                <div class="job-detail" v-if="!!jobDetail">
                    <RecJobOverview :job="jobDetail" @apply="handleApply" @more="toMore"></RecJobOverview>
                </div>

                <div class="job-detail-empty" v-else>
                    <div class="empty-header flex-center">
                        <div class="header-left">
                            <div class="empty-block block-1"></div>
                            <div class="empty-block block-2"></div>
                        </div>

                        <div class="empty-block"></div>
                    </div>

                    <div class="empty-content" v-for="item in 3" :key="item">
                        <div class="empty-block block-1"></div>
                        <div class="empty-block block-2"></div>
                        <div class="empty-block block-3"></div>
                    </div>
                </div>
            </div>

            <div class="empty-box flex-center" v-else>
                <img src="@/assets/img/company/job-empty.png" alt="" />

                <span>没有找到相关职位，打开App，查看全部职职位库，优质职位随心聊。</span>
            </div>
        </div>
    </div>
</template>

<script>
import FilterConfigs from "./job/FilterConfigs.vue";
import RecJobList from "@/components/recruitmentCenter/job/RecJobList.vue";
import RecCompanyList from "@/components/recruitmentCenter/job/RecCompanyList.vue";
import RecJobOverview from "@/components/recruitmentCenter/job/RecJobOverview.vue";

export default {
    name: "",
    data() {
        return {
            positionTypeList: [],
            filter: {
                keyword: "", // 搜索关键词
                city: undefined,
                experience: [],
                degree: [],
                salary: undefined,
                position_type: undefined,
            },
            pageParams: {
                page: 1,
                page_size: 5,
                total: 0,
            },

            currentJob: undefined,
            jobList: [],
            jobDetail: undefined,
        };
    },

    props: {
        company: {
            type: Object,
        },
    },

    created() {
        this.getPositionType();
        this.getJobList();
    },

    computed: {
        filterParams() {
            const params = {};

            if (this.filter.keyword) params.keyword = this.filter.keyword;
            if (this.filter.city) params.city = this.filter.city;
            if (this.filter.salary) params.salary = this.filter.salary;
            if (this.filter.experience.length > 0) params.experience = this.filter.experience.join(",");
            if (this.filter.degree.length > 0) params.degree = this.filter.degree.join(",");
            if (this.filter.position_type) params.position_type = this.filter.position_type;

            return params;
        },
    },

    components: { FilterConfigs, RecJobList, RecCompanyList, RecJobOverview },

    mounted() {},

    methods: {
        // 过滤条件修改
        handleFilterChange(val) {
            Object.assign(this.filter, val);
            this.getJobList();
        },

        // 获取职位类型列表
        getPositionType() {
            this.$httpStudent.axiosGetBy(this.$api.jobPositionTypeList, { company_id: this.company.id }, (res) => {
                if (res.code === 200) {
                    const list = res.data || [];
                    const allSum = list.reduce((prev, cur) => cur.num + prev, 0);

                    this.positionTypeList = [{ label: "全部", num: allSum }];
                    this.positionTypeList.push(...list.map((item) => ({ label: item.position_type, num: item.num })));
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 选择职位类型
        handleChangePositionType(val) {
            const prev = this.filter.position_type;

            if (val.label === "全部") this.filter.position_type = undefined;
            else this.filter.position_type = val.label;

            if (prev !== this.filter.position_type) this.getJobList();
        },

        // 获取职位列表
        getJobList() {
            const params = {
                page: this.pageParams.page,
                page_size: this.pageParams.page_size,
                company_id: this.company.id,
                ...this.filterParams,
            };

            this.$httpStudent.axiosGetBy(this.$api.jobPositionList, params, (res) => {
                if (res.code === 200) {
                    this.pageParams.total = res.data?.total || 0;
                    this.jobList = res.data?.list || [];

                    if (this.jobList.length > 0) {
                        this.currentJob = this.jobList[0].id;
                        this.getJobDetail(this.currentJob);
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 获取简历详情
        getJobDetail(id, clear = true) {
            if (clear) this.jobDetail = undefined;

            this.$httpStudent.axiosGetBy(this.$api.jobPositionDetail, { id }, (res) => {
                if (res.code === 200) {
                    this.jobDetail = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 投递简历
        handleApply() {
            if (!this.currentJob) return;

            this.$httpStudent.axiosPost(this.$api.jobApplyPosition, { position_id: this.currentJob }, (res) => {
                if (res.code === 200) {
                    this.getJobDetail(this.currentJob, false);
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 查看岗位详情
        toMore() {
            if (!this.currentJob) return;

            localStorage.removeItem("defaultActive");

            const path = this.$router.resolve({
                path: "/student/recruitmentCenter/job/detail",
                query: { id: this.currentJob },
            }).href;

            window.open(path, "_blank");
        },

        // 分页切换
        handlePageChange(val) {
            this.pageParams.page = val;

            this.getJobList();
        },
    },
};
</script>
<style lang="scss" scoped>
.recruitment_position {
    margin-top: 20px;
    width: 100%;
    border-radius: 12px 12px 12px 12px;

    .header_box {
        padding: 19px 23px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        margin-bottom: 16px;

        .condition_box {
            width: 100%;
            display: flex;
            align-items: first baseline;

            .label_box {
                width: 80px;
                height: 22px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #222229;
                flex-shrink: 0;
            }

            .value_box {
                display: flex;
                align-items: center;
                gap: 25px;
                flex-wrap: wrap;
                font-weight: 400;
                font-size: 14px;
            }

            .job-type-item {
                cursor: pointer;

                &.active {
                    color: #685ef5;
                }
            }
        }

        .condition_select {
            display: flex;
            align-items: center;
            margin-top: 20px;

            ::v-deep(.filter-item) {
                background: #f8f8f9;

                &.active {
                    background: rgba(104, 94, 245, 0.05);
                }
            }

            .filter-keyword {
                margin-left: 16px;
                width: 240px;
            }
        }
    }

    .job-box {
        .box-main {
            display: flex;
            gap: 16px;

            .job-list {
                width: 384px;

                .pagination {
                    margin-top: 12px;

                    ::v-deep(.el-pager) {
                        li {
                            min-width: 26px;
                            height: 26px;
                            background-color: #ffffff;
                            font-size: 12px;
                        }

                        li:hover {
                            color: #685ef5;
                        }

                        li:not(.disabled).active {
                            background-color: #685ef5;
                            color: #fff;
                        }
                    }

                    ::v-deep(.el-pagination) {
                        button {
                            min-width: 26px;
                            height: 26px;
                        }

                        button:not(.disabled) {
                            background-color: #fff;
                        }
                    }
                }
            }

            .job-detail,
            .job-detail-empty {
                flex: 1;
                min-width: 0;
                height: fit-content;
                background-color: #ffffff;
                padding: 16px 30px 20px 30px;
                border-radius: 16px;
            }

            .job-detail-empty {
                .empty-block {
                    background-color: #f2f4f7;
                    border-radius: 4px;
                    min-height: 16px;
                }

                .empty-header {
                    justify-content: space-between;

                    .header-left {
                        .empty-block.block-1 {
                            width: 300px;
                        }

                        .empty-block.block-2 {
                            width: 200px;
                            margin-top: 10px;
                        }
                    }

                    .empty-block {
                        height: 30px;
                        width: 150px;
                    }
                }

                .empty-content {
                    margin-top: 10px;
                    padding-top: 10px;
                    position: relative;

                    &::before {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        top: 0;
                        left: 0;
                        background-color: #f4f6f8;
                    }

                    .empty-block + .empty-block {
                        margin-top: 8px;
                    }

                    .block-1 {
                        width: 150px;
                        height: 25px;
                    }

                    .block-2 {
                        width: 250px;
                        height: 14px;
                    }

                    .block-3 {
                        width: 100%;
                        height: 100px;
                    }
                }
            }
        }

        .empty-box {
            height: 500px;
            background-color: #ffffff;
            border-radius: 16px;
            flex-direction: column;
            gap: 16px;

            img {
                width: 200px;
                height: 117px;
                object-fit: cover;
            }

            span {
                display: inline-block;
                width: 370px;
                white-space: pre-wrap;
                text-align: center;
                color: #999;
            }
        }
    }
}
::v-deep .el-input__inner {
    height: 32px;
    background: #f8f8f9;
    border: none;
}
::v-deep .el-input__icon {
    line-height: 32px;
}
</style>
